{
  "title": "Prismatic Spray",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level evocation",
  "level": 7,
  "castingTime": "1 action",
  "range": "Self (60-foot cone)",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Eight multicolored rays of light flash from your hand. Each ray is a different color and has a different power and purpose. Each creature in a 60-foot cone must make a Dexterity saving throw. For each target, roll a d8 to determine which color ray affects it.",
    "d8",
    "Color",
    "Ray Effect",
    "1",
    "Red",
    "The target takes 10d6 fire damage on a failed save, or half as much damage on a successful one.",
    "2",
    "Orange",
    "The target takes 10d6 acid damage on a failed save, or half as much damage on a successful one.",
    "3",
    "Yellow",
    "The target takes 10d6 lightning damage on a failed save, or half as much damage on a successful one.",
    "4",
    "Green",
    "The target takes 10d6 poison damage on a failed save, or half as much damage on a successful one.",
    "5",
    "Blue",
    "The target takes 10d6 cold damage on a failed save, or half as much damage on a successful one.",
    "6",
    "Indigo",
    "On a failed save, the target is restrained. It must then make a Constitution saving throw at the end of each of its turns. If it successfully saves three times, the spell ends. If it fails its save three times, it permanently turns to stone and is subjected to the petrified condition. The successes and failures don’t need to be consecutive; keep track of both until the target collects three of a kind.",
    "7",
    "Violet",
    "On a failed save, the target is blinded. It must then make a Wisdom saving throw at the start of your next turn. A successful save ends the blindness. If it fails that save, the creature is transported to another plane of existence of the DM’s choosing and is no longer blinded. (Typically, a creature that is on a plane that isn’t its home plane is banished home, while other creatures are usually cast into the Astral or Ethereal planes.)",
    "8",
    "Special",
    "The target is struck by two rays. Roll twice more, rerolling any 8."
  ],
  "spellLists": ["bard", "sorcerer", "wizard"]
}
